/* ==========================================================================
   OliveDrab — showcase behaviours

   Two things live here, both progressive: without this file the markup still
   reads and still links correctly.

   1. Explore collections. The frame and the oversized title move through
      the collections on their own: with a mouse, while the cursor is
      anywhere over the section; on a touch screen, while the section is
      on screen. Pointing at one name still wins and holds it.
   2. Every woman, every role. The row advances on its own, lifting one frame
      at a time, and stops the moment a visitor touches it.

   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function reduced() {
    return window.OD && window.OD.prefersReduced ? window.OD.prefersReduced() : false;
  }

  /* ------------------------------------------------------------------ 1
     the image follows the cursor down the collection list              */

  function splitFeature(root) {
    if (root.dataset.odSfeatBound) return;
    root.dataset.odSfeatBound = '1';

    var media = $('[data-od-sfeat-media]', root);
    if (!media) return;

    var peeks = {};
    $$('[data-od-sfeat-peek]', media).forEach(function (img) {
      peeks[img.getAttribute('data-od-sfeat-peek')] = img;
    });
    if (!Object.keys(peeks).length) return;

    var shown = null;

    /* the title follows too, when the section asks for it */
    var title = $('[data-od-sfeat-title]', root);
    var words = {};
    if (title) {
      $$('[data-od-sfeat-word]', title).forEach(function (w) {
        words[w.getAttribute('data-od-sfeat-word')] = w;
      });
    }

    /* a long collection name is set smaller so it never runs past the frame */
    function fit() {
      if (!title) return;
      var room = root.getBoundingClientRect().width * 0.94;
      Object.keys(words).forEach(function (k) {
        var w = words[k];
        w.style.setProperty('--od-fit', '1');
        var natural = w.scrollWidth;
        if (natural > room && natural > 0) {
          w.style.setProperty('--od-fit', (room / natural).toFixed(3));
        }
      });
    }

    var wordNow = 'base';
    function titleTo(key) {
      if (!title) return;
      var next = key === null ? 'base' : String(key);
      if (!words[next] || next === wordNow) return;
      var old = words[wordNow];
      old.classList.remove('is-shown');
      old.classList.add('is-leaving');
      old.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () { old.classList.remove('is-leaving'); }, 600);
      words[next].classList.remove('is-leaving');
      words[next].classList.add('is-shown');
      if (next === 'base') words[next].removeAttribute('aria-hidden');
      wordNow = next;
    }

    if (title) {
      fit();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
      window.addEventListener('resize', fit, { passive: true });
    }

    /* the frame is a link as well as a picture, so it leads wherever it is
       looking; at rest it goes back to the section's own link */
    var toCollection = {};
    var labels = {};
    $$('[data-od-sfeat-link]', root).forEach(function (l) {
      var k = l.getAttribute('data-od-sfeat-link');
      toCollection[k] = l.getAttribute('href');
      var name = $('.od-sfeat__name', l);
      labels[k] = name ? name.textContent.trim() : '';
    });
    var baseHref = media.getAttribute('data-od-sfeat-base');
    var baseLabel = media.getAttribute('aria-label');

    function aimFrame(key) {
      if (media.tagName !== 'A' || !baseHref) return;
      var href = key !== null && toCollection[key] ? toCollection[key] : baseHref;
      media.setAttribute('href', href);
      var label = key !== null && labels[key] ? labels[key] : baseLabel;
      if (label) media.setAttribute('aria-label', label);
    }

    function show(key) {
      if (shown === key) return;
      if (shown !== null && peeks[shown]) peeks[shown].classList.remove('is-shown');
      shown = key;
      if (key !== null && peeks[key]) peeks[key].classList.add('is-shown');
      titleTo(key);
      aimFrame(key);
    }

    /* ---- the section moves through the collections on its own ---- */

    var order = Object.keys(peeks);
    var hold = Math.round((parseFloat(root.dataset.autoHold) || 2.5) * 1000);
    var wanted = root.dataset.autoCycle !== 'false' && order.length > 1;
    var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;

    var timer = null;
    var held = {};

    function running() {
      if (!wanted || reduced()) return false;
      for (var k in held) if (held[k]) return false;
      return true;
    }

    function step() {
      var at = order.indexOf(shown);
      show(order[(at + 1) % order.length]);
    }

    function run() {
      window.clearInterval(timer);
      timer = null;
      if (!running()) return;
      if (shown === null) show(order[0]);
      timer = window.setInterval(step, hold);
    }

    function rest(why, on) {
      held[why] = on;
      if (on) { window.clearInterval(timer); timer = null; }
      else run();
    }

    $$('[data-od-sfeat-link]', root).forEach(function (link) {
      var key = link.getAttribute('data-od-sfeat-link');

      /* pointerenter rather than mouseover, so a touch that becomes a tap
         does not leave a picture stuck in the frame */
      link.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        rest('name', true);
        show(key);
      });

      /* keyboard traversal gets the same preview */
      link.addEventListener('focus', function () { rest('name', true); show(key); });
    });

    var list = $('.od-sfeat__links', root);
    if (list) {
      /* leaving the list hands the section back to its own clock; if the
         cursor has left the section too, pointerleave below rests it. */
      list.addEventListener('pointerleave', function () { rest('name', false); });
      list.addEventListener('focusout', function (e) {
        if (!list.contains(e.relatedTarget)) rest('name', false);
      });
    }

    if (!wanted) {
      /* without the clock, leaving the list returns to the resting image */
      if (list) list.addEventListener('pointerleave', function () { show(null); });
      return;
    }

    if (canHover) {
      /* a mouse starts it by being over the section at all, and leaving
         puts the resting image back */
      held.away = true;
      root.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        rest('away', false);
      });
      root.addEventListener('pointerleave', function () {
        rest('away', true);
        show(null);
      });
      root.addEventListener('focusin', function () { rest('away', false); });
    } else if ('IntersectionObserver' in window) {
      /* no cursor to wait for: it runs while the section is on screen */
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { rest('away', !entry.isIntersecting); });
      }, { threshold: 0.2 }).observe(root);
    } else {
      run();
    }

    document.addEventListener('visibilitychange', function () { rest('hidden', document.hidden); });
  }

  /* ------------------------------------------------------------------ 2
     the row advances on its own, one frame lifted at a time            */

  function imageRow(root) {
    if (root.dataset.odRowBound) return;
    root.dataset.odRowBound = '1';

    var items = $$('[data-od-row-item]', root);
    if (items.length < 2) return;

    var hold = parseInt(root.dataset.autoHold, 10) || 3200;
    var slide = root.dataset.autoSlide !== 'false';
    var scroller = $('[data-od-irow]', root);
    var i = 0;
    var timer = null;
    var paused = false;

    /* the scroll the script starts itself, so the listener below can tell it
       apart from a visitor's own swipe */
    var selfScrolling = 0;

    function bring(el) {
      if (!slide || !scroller || !el) return;
      if (scroller.scrollWidth <= scroller.clientWidth + 4) return;

      var target = el.offsetLeft - (scroller.clientWidth - el.offsetWidth) / 2;
      var max = scroller.scrollWidth - scroller.clientWidth;
      target = Math.max(0, Math.min(target, max));
      if (Math.abs(target - scroller.scrollLeft) < 4) return;

      selfScrolling = Date.now();
      if (scroller.scrollTo) {
        scroller.scrollTo({
          left: target,
          behavior: reduced() ? 'auto' : 'smooth'
        });
      } else {
        scroller.scrollLeft = target;
      }
    }

    function mark(n) {
      items.forEach(function (el, idx) {
        el.classList.toggle('is-lit', idx === n);
      });
      bring(items[n]);
    }

    function step() {
      i = (i + 1) % items.length;
      mark(i);
    }

    function start() {
      if (timer || paused || reduced()) return;
      timer = window.setInterval(step, hold);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    /* A visitor's own attention wins: pointing at a frame lights that one and
       holds it until the cursor leaves. */
    items.forEach(function (el, idx) {
      el.addEventListener('pointerenter', function () {
        paused = true;
        stop();
        i = idx;
        mark(i);
      });
      el.addEventListener('focusin', function () {
        paused = true;
        stop();
        i = idx;
        mark(i);
      });
    });

    root.addEventListener('pointerleave', function () {
      paused = false;
      start();
    });

    /* A visitor's own swipe takes the row over. It hands back after a rest,
       carrying on from wherever they left it rather than jumping. */
    if (scroller) {
      var settle = null;
      scroller.addEventListener('scroll', function () {
        if (Date.now() - selfScrolling < 900) return;

        paused = true;
        stop();
        window.clearTimeout(settle);
        settle = window.setTimeout(function () {
          /* pick up from the frame nearest the middle of the view */
          var mid = scroller.scrollLeft + scroller.clientWidth / 2;
          var best = 0;
          var bestGap = Infinity;
          items.forEach(function (el, idx) {
            var gap = Math.abs(el.offsetLeft + el.offsetWidth / 2 - mid);
            if (gap < bestGap) { bestGap = gap; best = idx; }
          });
          i = best;
          mark(i);
          paused = false;
          start();
        }, 2200);
      }, { passive: true });
    }

    /* Only runs while it is on screen. The threshold has to be zero: this
       section is taller than a phone screen, so asking for a quarter of it to
       be visible would mean it never starts at all. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start();
          else stop();
        });
      }, { threshold: 0 });
      io.observe(root);
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    mark(0);
  }

  /* ------------------------------------------------------------------ 3
     the drifting row: the motion itself is CSS; this only rests it while
     the section is off screen or the tab is hidden, so it costs nothing
     when nobody is looking                                              */

  function driftRow(root) {
    if (root.dataset.odDriftBound) return;
    root.dataset.odDriftBound = '1';

    var onScreen = true;
    function sync() {
      root.classList.toggle('is-away', !onScreen || document.hidden);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { onScreen = entry.isIntersecting; });
        sync();
      }, { threshold: 0 }).observe(root);
    }
    document.addEventListener('visibilitychange', sync);

    /* the frames the row carries in from off screen are revealed as they
       arrive, rather than waiting on a scroll that never comes */
    $$('.od-irow__item[data-od-r]', root).forEach(function (el) { el.classList.add('od-in'); });
  }

  /* ------------------------------------------------------------------ 4
     one row of equal frames with a single large one. Every few seconds
     the row moves along by one; the frame arriving in the featured place
     grows while the one leaving it returns to size. Each frame is placed
     from its slot, so position and size glide together in one move.    */

  function featureRow(root) {
    if (root.dataset.odFeatureBound) return;
    root.dataset.odFeatureBound = '1';

    var scroller = $('.od-irow__scroll--feature', root);
    var track = $('[data-od-feature-track]', root);
    var items = $$('[data-od-feature-item]', root);
    if (!scroller || !track || items.length < 3) return;

    var n = items.length;
    var hold = parseInt(root.dataset.hold, 10) || 3200;
    var place = root.dataset.featurePos || 'third';
    var offset = 0;
    var slots = items.map(function () { return null; });
    var size = { small: 0, big: 0, gap: 0, gutter: 0, view: 0, speed: 900 };

    /* the sizes are CSS values that depend on the screen, so they are read
       from a hidden probe rather than repeated here */
    function px(expr) {
      var probe = document.createElement('span');
      probe.style.cssText = 'position:absolute;visibility:hidden;height:0;width:' + expr;
      root.appendChild(probe);
      var w = probe.getBoundingClientRect().width;
      root.removeChild(probe);
      return w;
    }

    function measure() {
      /* a phone can ask for its own place for the large frame */
      var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      place = (phone && root.dataset.featurePosM) || root.dataset.featurePos || 'third';
      size.small = px('var(--od-feat-small)');
      size.big = px('var(--od-feat-big)');
      size.gap = px('var(--od-feat-gap)');
      size.gutter = px('var(--od-gutter)');
      size.view = scroller.clientWidth;
      size.speed = parseFloat(getComputedStyle(root).getPropertyValue('--od-feat-speed')) || 900;
    }

    function featured() {
      var step = size.small + size.gap;
      if (place === 'centre') {
        var room = size.view / 2 - size.big / 2 - size.gutter;
        return Math.max(0, Math.floor(room / step));
      }
      var want = place === 'second' ? 1 : 2;
      // on a narrow screen the large frame moves in until it fits whole
      var fits = Math.floor((size.view - size.gutter - size.big) / step);
      return Math.max(0, Math.min(want, fits));
    }

    function layout(animate) {
      var f = featured();
      var step = size.small + size.gap;
      var start = size.gutter;
      if (place === 'centre') start = size.view / 2 - size.big / 2 - f * step;

      items.forEach(function (el, i) {
        var slot = ((i - offset) % n + n) % n;
        if (slot === n - 1) slot = -1; // the one that has just left, out of sight on the left
        var x;
        if (slot < 0) {
          /* centred, the frame before the large one is part of the picture:
             small, large, small. Elsewhere it waits out of sight. */
          x = place === 'centre' && f === 0 ? start - step : start - step - size.small;
        } else {
          x = start + slot * step + (slot > f ? size.big - size.small : 0);
        }

        var was = slots[i];
        var jump = !animate || was === null || Math.abs(slot - was) > 1;
        el.classList.toggle('is-jump', jump);
        el.classList.toggle('is-featured', slot === f);
        el.style.transform = 'translate3d(' + Math.round(x) + 'px, 0, 0)';
        slots[i] = slot;
      });

      // let the jumps land before transitions return
      void track.offsetWidth;
      window.requestAnimationFrame(function () {
        items.forEach(function (el) { el.classList.remove('is-jump'); });
      });
    }

    function go(dir) {
      offset = (offset + dir + n) % n;
      layout(true);
    }

    /* ---- the clock ---- */
    var timer = null;
    var reasons = {};
    function running() {
      if (reduced()) return false;
      for (var k in reasons) if (reasons[k]) return false;
      return true;
    }
    function schedule() {
      window.clearTimeout(timer);
      if (!running()) return;
      timer = window.setTimeout(function () {
        go(1);
        schedule();
      }, hold + size.speed);
    }
    function pause(why, on) {
      reasons[why] = on;
      if (on) window.clearTimeout(timer);
      else schedule();
    }

    /* The row keeps moving with a cursor over it; the client read the old
       pause-on-hover as the row being broken. Only keyboard focus holds it,
       so a mouse click never leaves it stuck. */
    scroller.addEventListener('focusin', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches(':focus-visible')) pause('focus', true);
    });
    scroller.addEventListener('focusout', function (e) { if (!scroller.contains(e.relatedTarget)) pause('focus', false); });

    /* a frame that is pointed at, clicked or tapped comes to the large place,
       one step at a time so the glide stays smooth; the large one itself
       follows its link */
    var walking = null;
    function bringToFeature(el) {
      var i = items.indexOf(el);
      if (i < 0) return false;
      var f = featured();
      var slot = ((i - offset) % n + n) % n;
      if (slot === n - 1) slot = -1;
      var d = slot - f;
      if (d === 0) return false;
      if (d > n / 2) d -= n;
      if (d < -n / 2) d += n;
      window.clearTimeout(walking);
      pause('walk', true);
      var dir = d > 0 ? 1 : -1;
      var left = Math.abs(d);
      (function stepOnce() {
        go(dir);
        left -= 1;
        if (left > 0) {
          walking = window.setTimeout(stepOnce, Math.round(size.speed * 0.55));
        } else {
          walking = window.setTimeout(function () { pause('walk', false); }, size.speed);
        }
      })();
      return true;
    }

    /* ---- a swipe moves it by hand, and holds it for a moment ---- */
    var downX = null, downY = null, swiped = false, resume = null;
    scroller.addEventListener('pointerdown', function (e) {
      downX = e.clientX; downY = e.clientY; swiped = false;
      pause('touch', true);
    });
    scroller.addEventListener('pointerup', function (e) {
      if (downX === null) return;
      var dx = e.clientX - downX, dy = e.clientY - downY;
      downX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        go(dx < 0 ? 1 : -1);
      }
      window.clearTimeout(resume);
      resume = window.setTimeout(function () { pause('touch', false); }, e.pointerType === 'touch' ? 2600 : 0);
    });
    scroller.addEventListener('pointercancel', function () { downX = null; pause('touch', false); });
    // a swipe that ends over a frame must not also follow its link
    scroller.addEventListener('click', function (e) {
      if (swiped) { e.preventDefault(); swiped = false; return; }
      var el = e.target.closest('[data-od-feature-item]');
      if (el && bringToFeature(el)) e.preventDefault();
    }, true);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { pause('away', !entry.isIntersecting); });
      }, { threshold: 0 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () { pause('hidden', document.hidden); });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { measure(); layout(false); }, 120);
    }, { passive: true });

    measure();
    layout(false);
    scroller.classList.add('is-ready', 'od-in');

    /* the section is skipped by the browser until it nears the screen, so
       its width may not be known yet; measure again once it is */
    if (!size.view && 'ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        if (!scroller.clientWidth) return;
        measure(); layout(false); ro.disconnect();
      });
      ro.observe(scroller);
    }
    schedule();
  }

  function boot(scope) {
    $$('[data-od-sfeat]', scope || document).forEach(splitFeature);
    $$('[data-od-row-auto]', scope || document).forEach(imageRow);
    $$('[data-od-row-drift]', scope || document).forEach(driftRow);
    $$('[data-od-row-feature]', scope || document).forEach(featureRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* the theme editor re-renders a section in place */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
